<template>
    <div class="vx-flex vx-items-center vx-justify-between vx-gap-4">
        <div class="vx-flex-grow">
            <span class="vx-text-base vx-font-extrabold vx-text-slate-700 vx-text-md">{{ feature.name }}</span>
            <div class="vx-text-sm vx-text-slate-700">{{ feature.description }}</div>
        </div>
        <div class="flex-shrink-0">
            <vx-toggle v-model="feature.enabled" @update:modelValue="toggleFeature" size="lg"></vx-toggle>
        </div>
    </div>
</template>

<script setup>
import { VxToggle } from '@voxie/frontend-components';
import { ref } from 'vue';
import adminFeaturesClient from '~/services/adminFeaturesClient';
import { HTTP_INTERNAL_SERVER_ERROR, HTTP_CONFLICT } from '~/support/HttpStatuses';
import { useToasted } from '~/composables/useToasted';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
});

const feature = defineModel(Object);
const toasted = useToasted();
const toggling = ref(false);

const toggleFeature = async () => {
    if (toggling.value) {
        return;
    }

    toggling.value = true;

    try {
        // enabled is already changed to required in this step, so we need to call the appropriate method
        if (feature.value.enabled) {
            await adminFeaturesClient.enableFeature(props.teamId, feature.value.id);
            toasted.success(`${feature.value.name} has been enabled.`);
        } else {
            await adminFeaturesClient.disableFeature(props.teamId, feature.value.id);
            toasted.success(`${feature.value.name} has been disabled.`);
        }
    } catch (e) {
        console.error(e);

        // revert value if there is en error
        if (e?.response?.status === HTTP_CONFLICT) {
            feature.value.enabled = e?.request?.requestMethod === 'POST';
        } else {
            feature.value.enabled = !feature.value.enabled;
        }

        if (e?.response?.status >= HTTP_INTERNAL_SERVER_ERROR) {
            toasted.global.platform_error();
            return;
        }

        toasted.error(e.response?.data?.message || 'Something went wrong.');
    } finally {
        toggling.value = false;
    }
};
</script>
